module.exports = __webpack_public_path__ + "img/34.7.Chla.eb400e68.png";